module.exports = __webpack_public_path__ + "static/img/fashionaccessories.57f807d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/fashionaccessories.jpg
// module id = IzJR
// module chunks = 1